import mixpanel from "mixpanel-browser";
import { InAppMixpanelHandlers } from "./inAppMixpanelHandlers";

export class Mixpanel {
  static start() {
    if (process.env.VUE_APP_MixpanelEnabled !== "true") return;

    mixpanel.init(process.env.VUE_APP_MixpanelProjectToken, {
      api_method: "POST",
      api_transport: "XHR",
      batch_requests: true,
      batch_size: Number(process.env.VUE_APP_MixpanelConfigBatchSize),
      batch_flush_interval_ms: Number(process.env.VUE_APP_MixpanelConfigBatchFlushIntervalMS),
      batch_request_timeout_ms: Number(process.env.VUE_APP_MixpanelConfigBatchRequestTimeoutMS),
      cookie_domain: "",
      cookie_expiration: Number(process.env.VUE_APP_MixpanelConfigCookieExpiration),
      cross_site_cookie: false,
      cross_subdomain_cookie: true,
      debug: Boolean(process.env.VUE_APP_MixpanelConfigDebugMode === "true"),
      disable_persistence: false,
      ip: Boolean(process.env.VUE_APP_MixpanelConfigCollectLocation === "true"),
      opt_out_tracking_by_default: false,
      opt_out_persistence_by_default: false,
      opt_out_tracking_persistence_type: "localStorage",
      opt_out_tracking_cookie_prefix: undefined,
      persistence: "cookie",
      persistence_name: "",
      property_blacklist: [],
      secure_cookie: true,
      track_links_timeout: 300,
      upgrade: false,
      xhr_headers: {},
      ignore_dnt: false,
    });

    InAppMixpanelHandlers.handleAll();
  }
}

export const prop = Object.freeze({
  languages: Object.freeze({
    th: "Thai",
    en: "English",
  }),
  loginSources: Object.freeze({
    0: "Email",
    1: "Google",
  }),
});
